import { useEffect, useRef } from "react";

/** Lance `effect` après `delay` ms d'inactivité sur `deps`. Ignore le premier
 *  rendu (pas de sauvegarde au montage). Sert à l'enregistrement automatique.
 *  Au DÉMONTAGE, si un enregistrement est encore en attente (timer non écoulé),
 *  il est exécuté immédiatement → aucune perte de saisie lors d'une navigation
 *  interne (clic logo / fil d'ariane) en pleine édition. */
export function useDebouncedEffect(effect: () => void, deps: unknown[], delay = 700) {
  const first = useRef(true);
  const cb = useRef(effect);
  cb.current = effect;
  const pending = useRef(false);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    pending.current = true;
    const t = setTimeout(() => { pending.current = false; cb.current(); }, delay);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);

  // Flush de sécurité au démontage (le clearTimeout ci-dessus annule le timer sans
  // déclencher la sauvegarde ; on la force ici si elle était en attente).
  useEffect(() => () => { if (pending.current) cb.current(); }, []);
}
